<!--
  Markup Rules cell.

  Saved per vendor in vendor_markup_rule. Each edit writes the whole set after a
  short pause, rather than on a Save button: the cell is a grid of small inputs
  inside a table row, and there is nowhere natural to put one per row.
-->
<ng-template #markupRulesTemplate let-row>
  <div class="markup-rules-cell">
    @for (rule of markupRulesFor(row.id); track $index) {
      <div class="markup-rule">
        <!--
          [selected] per option rather than [value] on the select: the options are
          rendered by the @for inside this element, and a value bound on the parent
          can be applied before they exist, which silently leaves the select blank.
        -->
        <select
          class="markup-rule-category"
          aria-label="Category"
          (change)="setRuleCategory(row.id, $index, $any($event.target).value)"
        >
          <option value="" [selected]="!rule.category">Select category</option>
          @for (category of mainCategories(); track category.id) {
            <option [value]="category.id" [selected]="rule.category === category.id + ''">
              {{ category.category_name }}
            </option>
          }
        </select>
        <input
          type="number"
          class="markup-rule-percentage"
          placeholder="%"
          min="0"
          step="1"
          [value]="rule.percentage"
          (input)="setRulePercentage(row.id, $index, $any($event.target).value)"
        />
        @if (markupRulesFor(row.id).length > 1) {
          <button
            type="button"
            class="markup-rule-remove"
            aria-label="Remove this rule"
            (click)="removeRule(row.id, $index)"
          >
            <mat-icon>close</mat-icon>
          </button>
        }
      </div>
    }
    <button type="button" class="markup-rule-add" (click)="addRule(row.id)">
      <mat-icon>add</mat-icon>
      Add rule
    </button>
    @if (savingRules().has(row.id)) {
      <span class="markup-rule-status">Saving…</span>
    } @else if (failedRules().has(row.id)) {
      <span class="markup-rule-status markup-rule-status--error">
        Not saved{{ failedRuleMessages()[row.id] ? " (" + failedRuleMessages()[row.id] + ")" : "" }} — edit to retry
      </span>
    }
  </div>
</ng-template>

<div class="main-content">
  <div class="header-actions">
    <h4 class="card-title">Vendor List</h4>
    <div style="display: flex; gap: 8px; align-items: center;">
      <fh-refresh-button [refresh]="refreshData" />
      <button mat-stroked-button color="primary" (click)="openSendEmailDialog()">
        <mat-icon>email</mat-icon>
        Send Email
      </button>
      <button mat-raised-button color="primary" (click)="addVendor()">
        <mat-icon>add</mat-icon>
        Add Vendor
      </button>
    </div>
  </div>

  <!-- showResetButton=false: Reset button is injected inline as the 3rd grid slot -->
  <fh-filter-bar [showResetButton]="false">
    <fh-form-autocomplete
      [options]="countryOptions()"
      [label]="'Country'"
      [placeholder]="'Select country...'"
      [showCounts]="false"
      appearance="outline"
      [formControl]="countryFilterFormControl"
      (selectionChange)="onCountryChange($any($event))"
    />

    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Search Vendors</mat-label>
      <input
        matInput
        [value]="searchText()"
        (input)="searchText.set($any($event.target).value)"
        (keyup.enter)="onSearchChange(searchText())"
        placeholder="Search by name, email..."
      />
      <button matSuffix mat-icon-button (click)="onSearchChange(searchText())">
        <mat-icon>search</mat-icon>
      </button>
      @if (searchText()) {
        <button
          matSuffix
          mat-icon-button
          (click)="searchText.set(''); onSearchChange('')"
          class="clear-button"
        >
          <mat-icon>clear</mat-icon>
        </button>
      }
    </mat-form-field>

    <!-- 3rd grid slot: Reset button sits inline to the right of Search Vendors -->
    <div class="reset-inline">
      <button mat-stroked-button (click)="onResetFilters()" class="reset-btn">
        <mat-icon>refresh</mat-icon>
        Reset Filters
      </button>
    </div>
  </fh-filter-bar>

  <fh-data-table
    [config]="tableConfig()"
    [sortProp]="sortProp()"
    [sortDir]="sortDir()"
    [pageIndex]="pageIndex()"
    [pageSize]="pageSize()"
    [actions]="tableActions()"
    (sortChange)="onSortChange($event)"
    (pageChange)="onPageChange($event)"
  />
</div>
